var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalmartProductsScraper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 4.44048,
    y1: 0.88619,
    x2: 81.05694,
    y2: 83.47983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd67b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43354,
    stopColor: "#ffc42a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48883,
    stopColor: "#ffc220"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eb8820"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M78.17747,88.61091c-18.78499,2.12302-37.56996,2.12302-56.35494,0-5.49081-.62055-9.8129-4.94264-10.43345-10.43345-2.12301-18.78497-2.12301-37.56995,0-56.35493.62055-5.49081,4.94265-9.8129,10.43346-10.43345,18.78498-2.12301,37.56995-2.12301,56.35494,0,5.49081.62055,9.8129,4.94264,10.43346,10.43345,2.12301,18.78497,2.12301,37.56995,0,56.35492-.62055,5.49081-4.94265,9.8129-10.43345,10.43345Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M61.88593,49.01825l-.00311-.00311c-.96082,0-1.72266.53796-1.72266,1.19092l.58459,6.60748c.06219.39801.55035.70587,1.14117.70587.59076,0,1.07587-.31097,1.14111-.70587l.58771-6.60748c0-.65295-.76801-1.18781-1.72882-1.18781Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M65.45862,63.68225c-.31091.50995-.27051,1.08521.04041,1.34326l5.43219,3.83392c.56281.31091,1.40857-.06842,1.89362-.89862s.39801-1.76306-.17102-2.09265l-6.01361-2.80469c-.07117-.02795-.14746-.04065-.22388-.03729v-.01868c-.41302.04779-.77368.30188-.9577.67474Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M61.88593,65.78113l-.00311-.00623c-.58771,0-1.07587.31091-1.13806.7027l-.58459,6.60754c0,.65295.76495,1.19086,1.72577,1.19086s1.72882-.5379,1.72882-1.19086l-.58771-6.60132c-.06525-.39801-.55035-.7027-1.14111-.7027Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M70.9281,54.4162l-5.43219,3.82458c-.31091.25494-.3327.8302-.03729,1.34326.29541.50995.80536.77734,1.18158.62189l6.01361-2.79846c.56903-.32648.64984-1.24377.17102-2.08954-.28278-.5517-.82111-.92688-1.43658-1.00122l.00623-.01556c-.16309-.00513-.3244.03467-.46637.11505Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M58.27277,58.23767l-5.43213-3.80591c-.14197-.08044-.30334-.12024-.46643-.11505v-.01556c-.6134.08087-1.14685.46057-1.42407,1.01367-.48199.83331-.39801,1.76306.16479,2.08954l6.01355,2.79846c.37628.13995.88623-.1275,1.18158-.62189.31097-.51306.27368-1.08832-.03729-1.34326Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M57.13159,63.0448l-6.01355,2.81714c-.56592.32959-.6499,1.24377-.16791,2.09265.48193.84888,1.3277,1.2251,1.8905.89862l5.43213-3.79968c.31097-.25812.33582-.83337.04041-1.34326-.18402-.37286-.54462-.62695-.9577-.67474v-.02802c-.07642-.0036-.15271.00909-.22388.03729Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M64.15271,35.18842l-5.60986-3.23883-18.48676,10.67346,6.79388,3.92236c.36639.21155.81787.21155,1.18433,0l16.11835-9.3056c.78961-.45587.78961-1.59552.00006-2.05139Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30.73199,37.23987l5.13184,2.96283,18.48712-10.67334-6.31641-3.64673c-.36646-.21155-.81793-.21155-1.18433,0l-16.11823,9.30585c-.78961.45587-.78961,1.59552,0,2.05139Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.58606,40.84149c-.76733-.44305-1.7265.11078-1.7265.99683v18.68835c0,.41119.21936.7912.5755.99683l16.18445,9.34412c.7674.44299,1.72656-.11078,1.72656-.99683v-18.68817c0-.41125-.21936-.7912-.5755-.99683l-6.87177-3.96747v9.87964l-4.19208-2.17682v-10.12323l-5.12067-2.95642Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalmartProductsScraper);
export default __webpack_public_path__ + "static/media/walmart-products-scraper.d3b579a4eb81c0b52c5ae699978cdfb2.svg";
export { ForwardRef as ReactComponent };